/**
 * WebAction umoznuje ze vsech elementu odpovidajich selectoru
 * odebrat danou css tridu a tuto pak znovu pridat na rodice
 * triggeru.
 *
 * Markup:
 *   div.list
 *     div.item
 *       span.trigger
 *         data-action="switchClass"
 *         data-action-trigger="click"
 *         data-action-class="active"
 *         data-action-target=".list .item"
 *     div.item
 *       span.trigger...
 *     div.item
 *       span.trigger...
 *     div.item
 *       span.trigger...
 *
 */
import 'element-closest';

export default (props, e) => {
	e.stopPropagation();
	const {
		actionClass,
		actionTarget,
		separator = ';',
	} = props;
	const { target } = e;

	if ( actionTarget ) {
		const targetSet = actionTarget.split(separator);
		targetSet.forEach(
			element => [ ...document.querySelectorAll(element) ].forEach(
				(elm) => {
					elm.classList.remove(actionClass);
					target.closest(element).classList.add(actionClass);
				},
			),
		);
	}
};



// WEBPACK FOOTER //
// ./fe/web-auto/src/js/webActions/switchClass.js